import { IcArrowTriangle } from '@assets/icons/24x24';
import { For, HStack, Icon, Text, VStack } from '@chakra-ui/react';
import { ScrollArea } from '@components/ui/ScrollArea';
import { FormattedMessage } from 'react-intl';

type Props = {
  instructions: string[];
};

export default function ProcedureInstructions({ instructions }: Readonly<Props>) {
  if (instructions.length === 0) {
    return null;
  }
  return (
    <ScrollArea backgroundColor="neutral.700">
      <VStack gap={2} paddingX={6} paddingY={4} width="100%" flex={1} alignItems="start">
        <Text color="neutral.300" textStyle="md">
          <FormattedMessage id="notification.procedure.step.instructions" />
        </Text>
        <For each={instructions}>
          {(instruction, index) => (
            <HStack gap={1} width="100%" key={`${instruction}-${index}`} align="start">
              <Icon as={IcArrowTriangle} boxSize="24px" color="neutral.300" />
              <Text>{instruction}</Text>
            </HStack>
          )}
        </For>
      </VStack>
    </ScrollArea>
  );
}
